import styled from "styled-components";

export const ConfirmPanel = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #eff3f5;
  min-width: 20rem;
  padding: 1rem 1.5rem;

  h3 {
    margin: 0;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.5rem;
`;

export const TitleContainer = styled.div``;

export const ValueContainer = styled.div`
  font-weight: 300;
`;

export const Actions = styled.div``;
